/**
 * Essentials24 Feature-Grid: Mobile carousel (scroll-snap + optional dots + keyboard).
 * Progressives Enhancement: Horizontal Wischen funktioniert ohne JS.
 */
(function () {
  var MQ = '(max-width: 749px)';

  function throttle(fn, wait) {
    var t = null;
    return function () {
      if (t) return;
      t = setTimeout(function () {
        t = null;
        fn();
      }, wait);
    };
  }

  function getSlideIndex(track, slides) {
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      var mid = s.offsetLeft + s.offsetWidth / 2;
      var dist = Math.abs(center - mid);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function scrollToSlide(track, slides, index) {
    var s = slides[index];
    if (!s) return;
    var smooth =
      typeof window.matchMedia === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    s.scrollIntoView({
      inline: 'center',
      block: 'nearest',
      behavior: smooth ? 'smooth' : 'auto',
    });
  }

  function mount(root) {
    if (root.getAttribute('data-pfg-mounted') === 'true') return;
    root.setAttribute('data-pfg-mounted', 'true');

    var track = root.querySelector('.essentials24-features-grid__items--carousel-track');
    var dotsHost = root.querySelector('[data-features-grid-dots]');
    if (!track || !dotsHost) return;

    var showDots = root.getAttribute('data-show-dots') === 'true';
    var slides = root.querySelectorAll('.essentials24-features-grid__carousel-slide');
    var mq = window.matchMedia(MQ);
    var dotButtons = [];

    function clearDots() {
      dotsHost.innerHTML = '';
      dotsHost.hidden = true;
      dotButtons = [];
    }

    function updateDots() {
      if (!dotButtons.length) return;
      var idx = getSlideIndex(track, slides);
      for (var i = 0; i < dotButtons.length; i++) {
        dotButtons[i].classList.toggle('is-active', i === idx);
        dotButtons[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
      }
    }

    function buildDots() {
      clearDots();
      if (!mq.matches || slides.length < 2 || !showDots) return;
      dotsHost.hidden = false;
      var navEl = document.createElement('div');
      navEl.className = 'essentials24-features-grid__dots-nav';
      navEl.setAttribute('role', 'group');
      navEl.setAttribute('aria-label', 'Kacheln');

      for (var i = 0; i < slides.length; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'essentials24-features-grid__dot';
          b.setAttribute(
            'aria-label',
            'Kachel ' + (idx + 1) + ' von ' + slides.length
          );
          b.addEventListener('click', function () {
            scrollToSlide(track, slides, idx);
          });
          navEl.appendChild(b);
          dotButtons.push(b);
        })(i);
      }
      dotsHost.appendChild(navEl);
      updateDots();
    }

    var onScroll = throttle(updateDots, 72);
    track.addEventListener('scroll', onScroll, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (!mq.matches || slides.length < 2) return;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        var i = getSlideIndex(track, slides);
        scrollToSlide(track, slides, Math.min(i + 1, slides.length - 1));
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        var j = getSlideIndex(track, slides);
        scrollToSlide(track, slides, Math.max(j - 1, 0));
      }
    });

    function onMqChange() {
      if (!mq.matches) {
        track.scrollLeft = 0;
      }
      buildDots();
      updateDots();
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onMqChange);
    }

    buildDots();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateDots);
    } else {
      requestAnimationFrame(updateDots);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-essentials24-features-grid]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
